import {
  TeamworkCommerceProcessingSettingsSchema,
  TeamworkCommerceReturnPurposeTextSource,
} from "@redotech/redo-integrations-definitions-common/integration/teamwork-commerce";
import {
  boolean,
  object,
  string,
  enum as zEnum,
  null as zNull,
  type infer as zInfer,
} from "zod";

export const setTeamworkCommerceIntegration = {
  name: "setTeamworkCommerceIntegration" as const,
  input: object({
    baseUrl: string(),
    apiKey: string(),
    processingSettings: TeamworkCommerceProcessingSettingsSchema.optional(),
    importReceiptSettings: object({
      enabled: boolean().optional(),
      excludeOriginalReceiptNumForGreenReturns: boolean().optional(),
      fillFromLocationId: string().optional(),
      globalCharges: object({
        exchangeAdjustmentChargeId: string().optional(),
        exchangeAdjustmentMemo: string().optional(),
        shippingChargeId: string().optional(),
      }).optional(),
      importReceiptLocationId: string().optional(),
      items: object({
        greenReturnItemSku: string().optional(),
        returnPurposeTextFallback: string().optional(),
        returnPurposeTextSource: zEnum(
          TeamworkCommerceReturnPurposeTextSource,
        ).optional(),
      }).optional(),
    }).optional(),
  }),
  output: zNull(),
};

export type SetTeamworkCommerceIntegrationInput = zInfer<
  typeof setTeamworkCommerceIntegration.input
>;
